var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 14 7", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.192 5.32c1.85-1.686 3.7-3.372 5.555-5.053a1.08 1.08 0 0 1 .433-.245.667.667 0 0 1 .732.299c.146.24.108.516-.102.729-.035.036-.074.069-.112.103L7.582 6.72c-.408.37-.756.373-1.158.007-2.05-1.865-4.098-3.732-6.15-5.596C.1.971-.024.796.004.565A.597.597 0 0 1 .432.048c.263-.09.508-.054.718.123.138.117.27.242.404.364l5.245 4.778c.06.054.108.116.213.231.08-.102.122-.17.18-.224z" })
  );
});